
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { ListIcon } from '@phosphor-icons/react';

export const Navbar: React.FC = () => {
    const { openAuthModal } = useAuth();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-carbon/90 backdrop-blur-lg border-b border-white/5 py-2' : 'bg-transparent py-4'}`}>
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                {/* Logo */}
                <div className="flex items-center gap-2 cursor-pointer group">
                    <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center group-hover:rotate-3 transition-transform">
                        <div className="w-4 h-4 bg-carbon rounded-full" />
                    </div>
                    <span className="text-xl font-heading font-bold text-white tracking-tight">EZ Art.</span>
                </div>

                {/* Desktop Links */}
                <div className="hidden md:flex items-center gap-8 bg-white/5 backdrop-blur-md px-6 py-2 rounded-full border border-white/5">
                    <a href="#" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors">Features</a>
                    <a href="#" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors">Solutions</a>
                    <a href="#" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors">Pricing</a>
                    <a href="#" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors">Academy</a>
                </div>

                {/* Actions */}
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => openAuthModal()}
                        className="hidden md:block text-sm font-bold text-zinc-300 hover:text-white transition-colors"
                    >
                        Log In
                    </button>
                    <button
                        onClick={() => openAuthModal()}
                        className="px-5 py-2 bg-white text-black text-sm font-bold rounded-full hover:bg-zinc-200 transition-colors"
                    >
                        Get Started
                    </button>
                    <button className="md:hidden text-white">
                        <ListIcon className="w-6 h-6" />
                    </button>
                </div>
            </div>
        </nav>
    );
};
